






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class SectionBar extends Vue {
  @Prop()
  title: string
}
